import type { MyPacksTabDef } from './MyPacksHeader';

type Counts = {
  cards: number;
  /** While a feed is still on its first load the count isn't known yet. */
  isLoading: boolean;
};

/**
 * "Cards (2)" label for sleek's Cards tab (partner mockup). Shipping carries
 * no count. The count stays off until the feed has answered, so the label
 * doesn't flash "(0)".
 */
export function withTabCounts(tabs: MyPacksTabDef[], { cards, isLoading }: Counts): MyPacksTabDef[] {
  if (isLoading) return tabs;
  return tabs.map((tab) => {
    if (tab.id === 'drops') return { ...tab, label: `${tab.label} (${cards})` };
    return tab;
  });
}
